import React from "react";
import Footer from "../components/Footer";
import Navbar1 from "../components/Navbar1";

function Portfolio() {
  return (
    <div>
        <Navbar1 />
        
        <div className="container-fluid sect3bgimage">
        <div className="col-lg-12 py-5 px-4">
          <div className="row">
            
            <div class="d-flex flex-column justify-content-Center align-items-center  col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="imgPort1"></div>
              {/* <div className="content1 py-3">SMART LIVING</div> */}
              <div className="subcontent1 mt-3">
              KR HOMES manages Suwanee Preserve -$40 Million (High-end villa projects)
              </div>
            </div>

           

            <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="imgPort2"></div>
              {/* <div className="content1 py-3">HUMAN IN MIND</div> */}
              <div className="subcontent1 mt-3">
              Fund manager's other portfolio experience:  

 

Radhe Shaym residential complex - $25 million, 

 

SRS Arkade- $10 million 
              </div>
            </div>
          </div>




          {/* <div className="row pt-lg-4">
            <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="img004"></div>
              <div className="content1 py-3">ATRACTIVE LOCATION</div>
              <div className="subcontent1">
                But indeed we both accuse them and lead them to be worthy of
                just hatred, who are present in the blanties of the present
              </div>
            </div>

          

            <div class="d-flex flex-column justify-content-Center align-items-center col-lg col-12 my-3 px-sm-4 mx-lg-1 aboutsect2img">
              <div className="img006"></div>
              <div className="content1 py-3">AWARDED REWARDS</div>
              <div className="subcontent1">
                But indeed we both accuse them and lead them to be worthy of
                just hatred, who are present in the blanties of the present
              </div>
            </div>
          </div> */}
        </div>
      </div>




      <div className="container sect3bcolor pt-5">
        <div className=" col-lg-12 pb-5">
          <div className="row">
            <div className="d-flex flex-column justify-content-center align-items-lg-start align-items-center col-lg-6">
              <div className="sect3aboutus text-lg-start text-center">
                Investment
              </div>

              <div className="sect3aboutus2 text-lg-start text-center">
              To find out current opportunities Please contact 
              </div>

              <div className="sect3aboutus2 text-lg-start text-center">
              Yugandhar Kummathi 
              </div>

              <div className="sect3aboutus2 text-lg-start text-center">
              +1 904 4368696 
              </div>

              <div className="sect3aboutus2 text-lg-start text-center">
             info@kpnservicesllc.com
              </div>


            </div>

            <div className="sect3aboutusimg col-lg-6 pt-lg-0 pt-4">
              <img
                src={require("../images/investm2.jpg")}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
      
        <Footer />
            </div>
  );
}

export default Portfolio;